// extracted by mini-css-extract-plugin
export default {"header":"AIHeader_header__lSZz6","titleWrapper":"AIHeader_titleWrapper__wJYPE","icon":"AIHeader_icon__yZMUk","title":"AIHeader_title__OUubT","subtitle":"AIHeader_subtitle__KVofQ"};